import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.html',
  styleUrls: ['./access-denied.scss']
})
export class AccessDeniedContainer {
}
